// 定义Modal组件的类型
import React, {useContext} from "react";
import './AIPlayTipsModal.css'
import {ThemeContext} from "../../../../../providers/themeContext/theme-context.tsx";
import CustomPopup from "../../../../../components/CustomPopup";

type PlayTipModalProps = {
    isOpen: boolean;
    onClose: () => void;
};
const AIPlayTipModal: React.FC<PlayTipModalProps> = ({isOpen, onClose}) => {
    // 主题管理器
    const {imgUrls} = useContext(ThemeContext);

    return (
        <CustomPopup isOpen={isOpen} onClose={onClose}>
            <div className="ai-tip-modal-container">
                {/*背景花纹*/}
                <img className="left-top" src={imgUrls.leftTopBgDialogUrl} alt="bg"/>
                <img className="right-bottom-icon z-index-minus-1" src={imgUrls.rightBottomBgDialogUrl} alt="bg"/>

                <div className="ai-tip-modal-title my-roboto-medium">How to play</div>
                <img onClick={onClose} className="ai-tip-modal-close-btn" src={imgUrls.closerBtnGreyUrl} alt="pic"/>
                <div>
                    <div className="ai-tip-modal-content-item padding-bottom-6 padding-top-6 margin-top-8 margin-left-right-auto">
                        <div className="width-248 margin-left-right-auto display-flex-column  margin-top-bottom-auto">
                            <li className="my-roboto-regular">You need to guess the word before the</li>
                            <div className="my-roboto-regular text-start margin-left-18 margin-top-6">AI does.</div>
                        </div>
                    </div>

                    <div className="ai-tip-modal-content-item-middle margin-top-8 align-center ">
                        <div className="width-248 margin-left-right-auto">
                            <li className="my-roboto-regular">The colors of the letters will change</li>
                            <div className="my-roboto-regular text-start margin-left-18 margin-top-6 ">to show if they are correct.</div>
                        </div>
                    </div>

                    <div className="ai-tip-modal-content-item padding-bottom-6 padding-top-6 margin-top-8 align-center ">
                        <div className="width-248 display-flex-column margin-left-right-auto margin-top-bottom-auto">
                            <li className="my-roboto-regular">Can you beat the AI? If you lose, try</li>
                            <div className="my-roboto-regular text-start margin-left-18 margin-top-6">again!</div>
                            {/*<div className="text-blue-color my-roboto-medium">3mins.</div>*/}
                        </div>
                    </div>
                </div>
                <div className="ai-examples-text my-roboto-medium">Examples</div>
                <img className="ai-help-detail-pic" src={imgUrls.helpPicUrl} alt="pic"/>
            </div>
        </CustomPopup>
    );
};

export default AIPlayTipModal;